import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import i18next from 'i18next';
import { useDocumentDirection } from '../hooks/useDocumentDirection';

export type Language = 'en' | 'ar';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  setLanguage: () => {},
});

const DirectionSync: React.FC = () => {
  useDocumentDirection();
  return null;
};

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const savedLang = (localStorage.getItem('language') as Language) || 'en';
  const [language, setLanguageState] = useState<Language>(savedLang);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('language', lang);
    (i18next as unknown as { changeLanguage: (lang: string) => void }).changeLanguage(lang);
  };

  useEffect(() => {
    (i18next as unknown as { changeLanguage: (lang: string) => void }).changeLanguage(language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <DirectionSync />
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
